// extracted by mini-css-extract-plugin
export default {"section":"styles_section__x3ymj","main":"styles_main__iKq0u","infoBlock":"styles_infoBlock__R7-zf","pagination":"styles_pagination__yot7o","display":"styles_display__ayKXn"};